import { render, staticRenderFns } from "./EmployeeConfiguration.vue?vue&type=template&id=39924dee&"
import script from "./EmployeeConfiguration.vue?vue&type=script&lang=js&"
export * from "./EmployeeConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports